<template>
    <div class="contact-inputs">
        <h2 class="mb-5">{{ $l10n.__('Informations de contact') }}</h2>
        <div class="flex-row">
            <el-form-item class="wp-5" prop="name" :label="$t.__('common.labels.name')">
                <el-input v-model="value.name" @input="$emit('input', value)"></el-input>
            </el-form-item>
            <el-form-item
                class="wp-5 ml-4"
                prop="forename"
                :label="$t.__('common.labels.first_name')"
            >
                <el-input v-model="value.forename" @input="$emit('input', value)"></el-input>
            </el-form-item>
        </div>

        <el-form-item
            prop="phone"
            :label="$t.__('common.labels.phone')"
            :error="errors.get('contactPhone')"
        >
            <tel-input
                mode="edit"
                class="wp-10 contact-input-tel"
                v-model="value.phone"
                @change="$emit('input', value)"
            />
        </el-form-item>

        <el-form-item prop="email" :label="$t.__('common.labels.email_address')">
            <el-input v-model="value.email" @input="$emit('input', value)"></el-input>
        </el-form-item>
    </div>
</template>

<script>
import TelInput from 'vcomponents/inputs/TelInput.vue';

export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    components: {
        TelInput,
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.contact-inputs {
    .intl-tel-input,
    .intl-tel-input input {
        width: 100%;
    }

    .el-form-item.is-error .contact-input-tel input {
        border: 1px solid $red !important;
        border-radius: 5px;
    }
}
</style>
